import { useQuery } from '../common';

export function useSignupFlow() {
  return useQuery().get('state') === '123456789012345678901234567890';
}
